import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HrAccordionComponent } from './hr-accordion.component';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from 'primeng/accordion';

@NgModule({
    declarations: [HrAccordionComponent],
    imports: [CommonModule, TranslateModule, AccordionModule],
    exports: [HrAccordionComponent],
})
export class HrAccordionModule {}
